import { defineMessages } from 'react-intl';

const messages = defineMessages({
  helpImages: {
    id: 'UseHelpSections.HelpImages',
    defaultMessage: 'What can I find out about product images?',
  },
  helpAdvancedSearch: {
    id: 'UseHelpSections.HelpAdvancedSerach',
    defaultMessage: 'Advanced search techniques',
  },
  helpAvailability: {
    id: 'UseHelpSections.HelpAvailability',
    defaultMessage: 'How can I find out where an item is available?',
  },
  helpCustomizingViews: {
    id: 'UseHelpSections.HelpCustomizingViews',
    defaultMessage: 'Customizing my viewing experience',
  },
  helpGeneralPLP: {
    id: 'UseHelpSections.HelpGeneralPLP',
    defaultMessage: 'How do I use search?',
  },
  helpGeneralPDP: {
    id: 'UseHelpSections.HelpGeneralPDP',
    defaultMessage: 'How do I use the product details page?',
  },
  helpMultiItemSearch: {
    id: 'UseHelpSections.HelpMultiItemSearch',
    defaultMessage: 'Can I just search for lists of items?',
  },
  helpSources: {
    id: 'UseHelpSections.HelpSources',
    defaultMessage: "I can't find the product information I'm looking for",
  },
});

export default messages;
